import { getClassFromSubject, getTeacherSubjects } from "./teacherSubjects";

export const CLASS_TEACHER_REQUIRES_SUBJECT_MSG =
    "Choose at least one subject in this class for the form teacher (use the assign dialog to pick class and subjects together).";

/** True when teacher has at least one subject assignment in the given class. */
export function teacherTeachesInClass(teacher, classId) {
    if (!teacher || !classId) return false;
    const cid = String(classId);
    return getTeacherSubjects(teacher).some((sub) => {
        const cls = getClassFromSubject(sub);
        return cls && String(cls._id) === cid;
    });
}

export function filterTeachersForClassHomeroom(teachersList, classId) {
    if (!Array.isArray(teachersList) || !classId) return [];
    return teachersList.filter((t) => teacherTeachesInClass(t, classId));
}

export function filterClassesForTeacherHomeroom(classOptions, teacher) {
    if (!teacher || !Array.isArray(classOptions)) return [];
    return classOptions.filter((c) => teacherTeachesInClass(teacher, c.id));
}
